export type AiAnalysisDetailsTab =
  | 'overview'
  | 'seo'
  | 'detector'
  | 'eeat'
  | 'geo';

export const aiAnalysisHistoryPath = (
  domainSlug: string,
  domain: string
) => `/content-tools/ai-analysis/history/${domainSlug}/${domain}`;

export const aiAnalysisDetailsPath = (
  tab: AiAnalysisDetailsTab,
  domainSlug: string,
  domain: string,
  id: string | number = 'last'
) => `/content-tools/ai-analysis/${tab}/${domainSlug}/${domain}/${id}`;
